import React, { createContext, useState, useContext, useEffect } from 'react';
import styles from './LoadingContext.module.scss';
// Import Logo của bạn để hiển thị lúc loading cho đẹp
// Giả sử logo nằm ở public hoặc assets, bạn chỉnh lại đường dẫn nhé
const LOGO_URL = "/logo.png"; 

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  // loadingCount giúp xử lý trường hợp có nhiều API gọi cùng lúc
  // Loading chỉ tắt khi TẤT CẢ các API đều đã xong (count về 0)
  const [loadingCount, setLoadingCount] = useState(0);

  const showLoading = () => setLoadingCount((prev) => prev + 1);
  const hideLoading = () => setLoadingCount((prev) => Math.max(0, prev - 1));

  // Hàm tiện ích để chạy 1 promise với loading
  const withLoading = async (promise) => {
    showLoading();
    try {
      const result = await promise;
      return result;
    } finally {
      hideLoading();
    }
  };

  // Khóa cuộn trang khi đang loading
  useEffect(() => {
    if (loadingCount > 0) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [loadingCount]);

  return (
    <LoadingContext.Provider value={{ showLoading, hideLoading, withLoading, isLoading: loadingCount > 0 }}>
      {children}
      
      {/* === GLOBAL LOADING OVERLAY === */}
      <div className={`${styles.loadingOverlay} ${loadingCount > 0 ? styles.active : ''}`}>
        <div className={styles.loadingContent}>
          {/* Vòng tròn xoay */}
          <div className={styles.spinnerRing}></div>
          
          {/* Logo ở giữa (tùy chọn) */}
          <div className={styles.logoWrapper}>
            <img src={LOGO_URL} alt="Loading..." />
          </div>
        </div>
        <p className={styles.loadingText}>Đang tải dữ liệu...</p>
      </div>
    </LoadingContext.Provider>
  );
};